import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import firebase from "firebase/app";
import "firebase/firestore";
import {Provider} from "react-redux";
import {createStore} from "redux";
import reducer from "./view/reducer";


const root = ReactDOM.createRoot(document.getElementById('root'));

const firebaseConfig = {
    apiKey: "AIzaSyAiGtx1EdCFJxk9unBR-Ptd7bnro7dqkRI",
    authDomain: "jeju-ang.firebaseapp.com",
    projectId: "jeju-ang",
    storageBucket: "jeju-ang.appspot.com",
    messagingSenderId: "677618657855",
    appId: "1:677618657855:web:de0c3e24433784b3c2e68a",
    measurementId: "G-8DZV3XNBYV"
};

firebase.initializeApp(firebaseConfig);
export const db = firebase.firestore();

const store = createStore(reducer);

root.render(
    <Provider store={store}>
        <React.StrictMode>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </React.StrictMode>
    </Provider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
